
import { Vue, Component } from 'vue-property-decorator'
import util from '@/utils/busi/util'
import UpdateLog from './updatelog.vue'
import DetailEdit from './detailedit.vue'
import DetailView from './detailview.vue'
import SchoolRoll from './schoolroll.vue'
import FeeDetail from './feedetail.vue'
import FeeLog from './feelog.vue'
import FeesChange from './feeschange.vue'
import { checkPermission } from '@/utils/permission'
import { signupUpdateYesLog, signupCheck } from '@/api/ordercenter'

@Component({
  name: 'detail',
  components: {
    FeesChange,
    DetailEdit,
    DetailView,
    UpdateLog,
    SchoolRoll,
    FeeDetail,
    FeeLog
  }
})

export default class OrderCenterDetail extends Vue {
  private checkPermission = checkPermission
  private params = util.getRouterParams()

  get isView () {
    return this.params ? (this.params.flag === 'view') : !1
  }

  private activeName = this.isView ? 'DetailView' : 'DetailEdit'

  private onBack () {
    this.$router.push({
      name: 'orderManagement'
    })
  }

  private async onSave () {
    (this.$refs.detail as any).validate(async () => {
      if (!this.params.stuName || (typeof this.params.stuSex !== 'number') || !this.params.stuPhone || !this.params.stuEthnic || !this.params.stuPaperworkNumber || (typeof this.params.stuPaperworkType !== 'number')) {
        (document.querySelector('#errorBlock') as any).scrollIntoView(true)
        return
      }
      await signupCheck({
        stuPaperworkNumber: this.params.stuPaperworkNumber,
        stuBusinessId: this.params.stuBusinessId,
        stuSchoolId: this.params.stuSchoolId,
        stuSubjectId: this.params.stuSubjectId,
        stuGradeId: this.params.stuGradeId
      }).then(async (res: any) => {
        if (res.code === 10000) {
          if (!res.object.flag) {
            this.$alert('报名信息已存在', '保存失败')
            return
          }
          await signupUpdateYesLog({
            ...this.params
          }).then((res: any) => {
            if (res.code === 10000) {
              this.$message(res.message)
            }
          })
        }
      })
    })
  }
}
